import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule} from '@angular/material/tabs';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatIconModule} from '@angular/material/icon';
import { MatDialogModule} from '@angular/material/dialog';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatDialogRef} from '@angular/material/dialog';
// import { MAT_DIALOG_DATA} from '@angular/material/';

import { MatInputModule } from '@angular/material/input';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';
import { SettingsRoutingModule } from 'src/app/modules/settings/settings-routings.module';
import { SettingsLandingComponent  } from './Components/settings-landing/settings-landing.component';
import { YourProfileViewToOthersComponent } from './Components/your-profile-view-to-others/your-profile-view-to-others.component';
import { LoginAndSecurityComponent } from './Components/login-and-security/login-and-security.component';
import { SettingsChangepasswordComponent } from './Components/changepassword/changepassword.component'; 
import { SharedModule } from '../../modules/shared/shared.module';
import {TabViewModule} from 'primeng/tabview';
import { DocumentExpiryAlertSettingsComponent } from './Components/document-expiry-alert-settings/document-expiry-alert-settings.component';
import { VideoCallLinkComponent } from './Components/settings-landing/video-call-link/video-call-link.component';
import { ChangeLanguageComponent } from './Components/change-language/change-language.component';
@NgModule({
  declarations: [SettingsLandingComponent,ChangeLanguageComponent, YourProfileViewToOthersComponent,LoginAndSecurityComponent,SettingsChangepasswordComponent, DocumentExpiryAlertSettingsComponent, VideoCallLinkComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatTabsModule,
    MatTooltipModule,
    MatDialogModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSidenavModule,
    MatCheckboxModule,
    MatRadioModule,
    SettingsRoutingModule,
    MatIconModule,
    TabViewModule,
    SharedModule
  ],
  entryComponents: [YourProfileViewToOthersComponent,LoginAndSecurityComponent,SettingsChangepasswordComponent, DocumentExpiryAlertSettingsComponent, ChangeLanguageComponent
  ],
  providers: [
    { provide: MatDialogRef, useValue: {} },
    // { provide: MAT_DIALOG_DATA, useValue: [] },
  ]
  
})
export class SettingsModule { }
